import React, { useMemo } from "react";
import Tab from "../Tab/Tab";

interface Props {
	tabs: React.JSX.Element[];
	active: string; // id
	split: boolean;
}

function TabWindow(props: Props) {
	const { tabs, active, split } = props;

	const activeTabs = useMemo(() => {
		const final = [];

		// In order to try and keep the non-used tabs alive still in the background...
		// SUPER EXPERIMENTAL AND WILL PROBABLY NOT WORK
		for (let i = 0; i < tabs.length; i++) {
			const tab = tabs[i];
			const isActive = active === tab.props.name;
			const tabHtml = <Tab key={`Tab-${tab.props.name}`} formGroup={tab} isActive={isActive} />;
			final.push(tabHtml);
		}

		return final;
	}, [tabs, active]);

	return <>{activeTabs}</>;
}

export default TabWindow;
